<div class="row">
  <div class="col-8 d-flex justify-content-between">
    <app-autocomplete class="w-100 mb-2" [getDataFunction]="searchUsers.bind(this)" [fields]="fields"
      placeholder="Search user" (valueChange)="onValueChange($event)" [(value)]="selectedUserId"></app-autocomplete>
    @if (selectedUserId) {
      <span class="e-icons icon-add e-icon-big ms-2 my-auto pb-1"
        title="{{ 'i18n.domain.export-configuration.configurations.overview.add-button-tooltip' | translate }}"
        (click)="addUserToGrid()">
      </span>
    }
  </div>
</div>
<div class="form-row row">
  <div class="col-8">
    <ejs-grid #grid class="grid-with-toolbar" width="100%" rowHeight="38" [dataSource]="permissionGroup.users"
      [allowSorting]="false" [allowFiltering]="false" [allowPaging]="false" [editSettings]="customEditSettings"
      (commandClick)="commandClicked($event)">
      <e-columns>
        <e-column field="userId" isPrimaryKey="true" [visible]="false"></e-column>
        <e-column field="user.userName"
          headerText="{{'i18n.domain.export-configuration.configurations.forms.general.grid.user-name' | translate}}"
          clipMode="EllipsisWithTooltip">
        </e-column>
        <e-column headerText="" [commands]='gridCommands' width='60px'></e-column>
      </e-columns>
    </ejs-grid>
  </div>
</div>
